import React from "react";
import styles from "./styles.module.css";

export default function ReportCardPagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;
  return (
    <nav className={styles.pagination} aria-label="صفحه‌بندی کارنامه‌ها">
      <button type="button" className={styles.button} disabled={page <= 1} onClick={() => onChange(page - 1)}>صفحه قبل</button>
      <span aria-live="polite">صفحه {page.toLocaleString("fa-IR")} از {totalPages.toLocaleString("fa-IR")}</span>
      <button type="button" className={styles.button} disabled={page >= totalPages} onClick={() => onChange(page + 1)}>صفحه بعد</button>
    </nav>
  );
}
